<template>
  <div class="layout-base">
    <oct-header></oct-header>

    <router-view></router-view>
  </div>
</template>

<script>
import OctHeader from '@/components/Header.vue'

export default {
  components: { OctHeader }
}
</script>
